// Automatic Capture Hints for Mitek/MiSnap ID-Verify

import { TFeedbackMap } from './FeedbackKeys';

const DefaultAutoCaptureHints: TFeedbackMap = {
    CV_NO_BARCODE_FOUND: 'No Barcode Detected',
    MISNAP_AXIS_ANGLE: 'Hold Phone Upright',
    MISNAP_HEAD_OUTSIDE: 'Place Face in Oval',
    MISNAP_HEAD_SKEWED: 'Look Straight Ahead',
    MISNAP_HEAD_TOO_CLOSE: 'Move Farther Away',
    MISNAP_HEAD_TOO_FAR: 'Get Closer',
    MISNAP_READY_POSE: 'Hold it There',
    MISNAP_SMILE: 'Smile!',
    MISNAP_STAY_STILL: 'Hold Still',
    MISNAP_STOP_SMILING: 'Stop Smiling',
    MISNAP_SUCCESS: 'Success',
    MITEK_ERROR_FOCUS: 'Hold Steady',
    MITEK_ERROR_FOUR_CORNER: 'Document Not Found',
    MITEK_ERROR_GLARE: 'Reduce Glare',
    MITEK_ERROR_MRZ_MISSING: 'Passport Not Detected',
    MITEK_ERROR_TOO_DARK: 'Too Dark. Use good lighting',
    NO_FACE_FOUND: 'No Face Detected',
} as const;

export default DefaultAutoCaptureHints;